import React from "react";
import TabbedHub from "@/components/TabbedHub";
import Profile from "@/pages/Profile";
import Leaves from "@/pages/Leaves";
import PerformanceReviews from "@/pages/PerformanceReviews";
import HR from "@/pages/HR";
import Assets from "@/pages/Assets";
import AdminUsers from "@/pages/AdminUsers";
import Recruitment from "@/pages/Recruitment";
import Grievances from "@/pages/Grievances";
import TeamWeeklyBoard from "@/pages/TeamWeeklyBoard";
import HolidayCalendarTab from "@/components/HolidayCalendarTab";
import usePermissions from "@/lib/usePermissions";
import { User, Plane, Award, FileText, Boxes, Users, Briefcase, ShieldAlert, LayoutGrid, CalendarDays } from "lucide-react";

export default function MyHR() {
  const can = usePermissions();

  // Flattened — `Profile` is a single leaf tab that opens the Account page
  // directly (no nested sub-hub). Leaves / Performance / My documents are
  // siblings; admin-only tabs (Team, Team board, Recruitment) sit alongside.
  // Phase 84.35 — Assets moved from Finance to People. Everyone sees the
  // register; edit permissions inside Assets.jsx already gate admin/CM.
  // Phase 84.44 — every tab here (except Profile, always visible) now has a
  // dedicated founder-managed page-view flag; nothing is universally on by
  // role anymore.
  const tabs = [
    { id: "profile",     label: "Profile",      icon: User,        render: () => <Profile /> },
    { id: "leaves",      label: "Leaves",       icon: Plane,       render: () => <Leaves />,             hidden: !can("my_hr_leaves") },
    { id: "performance", label: "Performance",  icon: Award,       render: () => <PerformanceReviews />, hidden: !can("performance_reviews") },
    { id: "documents",   label: "My documents", icon: FileText,    render: () => <HR />,                 hidden: !can("my_hr_documents") },
    { id: "holidays",    label: "Holiday calendar", icon: CalendarDays, render: () => <HolidayCalendarTab />, hidden: false },
    { id: "assets",      label: "Assets",       icon: Boxes,       render: () => <Assets />,             hidden: !can("my_hr_assets") },
    { id: "team",        label: "Team",         icon: Users,       render: () => <AdminUsers />,         hidden: !can("my_hr_team_view") },
    // Phase 84.10 — Team board is visible to any manager (admin/founder/CM),
    // gated by `team_board_view` — a narrower permission than `team_admin`
    // which reserves user CRUD for admins/founders only.
    { id: "team-board",  label: "Team board",   icon: LayoutGrid,  render: () => <TeamWeeklyBoard />,   hidden: !can("team_board_view") },
    { id: "recruitment", label: "Recruitment",  icon: Briefcase,   render: () => <Recruitment />,       hidden: !can("recruitment") },
    { id: "grievances",  label: "Grievances",   icon: ShieldAlert, render: () => <Grievances />,        hidden: !can("grievances_view") },
  ];

  return <TabbedHub hubKey="my-hr" tabs={tabs} />;
}
